export default {
  "content": "<path d=\"M5.5 19h-2V6h2v13zM10.5 19h-2V2h2v17zM15.5 19h-2V9h2v10zM20.5 19h-2V7h2v12z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};